module.exports = __webpack_public_path__ + "img/treasureland-logo.9c305040.svg";